import auth from '@/router/auth'
import TestKitCreate from '@/components/test-results/Create'
import TestKitUpdate from '@/components/test-results/Update'
import TestKitShow from '@/components/test-results/Show'

export default [
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-results/create',
    name: 'test-results-create',
    component: TestKitCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-results/update/:test_kit_id',
    name: 'test-results-update',
    component: TestKitUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-results/show/:test_kit_id',
    name: 'test-results-show',
    component: TestKitShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/test-results/router.js